// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getQuoteState } from "@insite/client-framework/Store/Data/Quotes/QuotesSelector";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import QuoteTotalDisplay from "@store/Library/Components/Toolkit/Quotes/QuoteTotalDisplay";
import React from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState) => ({
    quoteState: getQuoteState(state, state.pages.rfqQuoteDetails.quoteId),
    showPricing: state.context.showPricing,
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface RfqQuoteDetailsTotalStyles {}

export const rfqQuoteDetailsTotalStyles: RfqQuoteDetailsTotalStyles = {};

const styles = rfqQuoteDetailsTotalStyles;

const RfqQuoteDetailsTotal = ({ quoteState, showPricing }: Props) => {
    const quote = quoteState.value;

    if (!quote || !quote.quoteLineCollection || !showPricing) {
        return null;
    }

    return <QuoteTotalDisplay quote={quote} />;
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(RfqQuoteDetailsTotal),
    definition: {
        displayName: "Total",
        allowedContexts: ["RfqQuoteDetailsPage"],
        group: "RFQ Quote Details",
    },
};

export default widgetModule;
